"use strict";

exports.__esModule = true;

var _editor = require("@prisma-cms/editor");

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = _editor2.default;
module.exports = exports["default"];